define('modules/base/models/redirect.model',[
    'underscore',
    'backbone',
    'modules/base/models/base.model'
], function (_, Backbone, BaseModel) {
    var RedirectModel = BaseModel.extend({
        baseService: 'una/v1',
        base: 'auth',
        fetch: function(options) {
            options = options ? _.clone(options) : {};
            if (options.parse === void 0) options.parse = true;
            var model = this;
            var success = options.success;

            options.success = function(resp, status, xhr) {
                if (!model.set(model.parse(resp, options), options)) return false;
                if (success) success(model, resp, options);
                model.trigger('sync', model, resp, options);
            };
            //wrapError(this, options);
            return this.sync('read', this, options);
        },
        urlRoot:function(){
            var baseSub = "login.relpro.com";

            if(window.location && window.location.href && window.location.href.toLowerCase().indexOf("localhost") > -1){
                baseSub = "localhost/loginClientUI";
            } else if(window.location.origin.toLowerCase().indexOf("staging.relpro.com") > -1){
                baseSub = "lstaging.relpro.com";
            } else if(window.location.origin.toLowerCase().indexOf("test.relpro.com") > -1){
                baseSub = "ltest.relpro.com";
            }

            if(window.location.href.indexOf("http://") > -1){
                return 'http://' + baseSub + "/" + this.baseService + '/' + this.base;
            } else {
                return 'https://' + baseSub + "/" + this.baseService + '/' + this.base;
            }
            // return window.utils.makeUrl('prospector/v1/' + this.base);
        }
    });
    return RedirectModel;
});


